import styled from 'styled-components';

export const StyledContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;